<template>
  <div class="dialog-container">
    <h3 class="mt-0">Client Info</h3>
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="userDetails" :model="form" :rules="rules" label-width="30%">
          <el-form-item label="Name" prop="name">
            <el-input v-model="form.name" placeholder="Name"></el-input>
          </el-form-item>
          <el-form-item label="SSN (Last 4)" prop="last4">
            <masked-el-input v-model="form.last4" :mask="'####'" placeholder="Last 4 of SSN"></masked-el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Cancel</el-button>
        <w2-ad-hoc-pdf-button :payload="w2AdHocData" icon="fa fa-print">View W2</w2-ad-hoc-pdf-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Required } from '@/util/formValidators';
import MaskedElInput from '@/components/form-item/MaskedElInput.vue';
import W2AdHocPdfButton from '@/components/PDFButton/W2AdHoc';

export default {
  props: {
    callback: {
      type: Function,
      default: () => {},
    },
    paystubs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        name: null,
        last4: null,
      },
      rules: {
        name: [Required],
        last4: [Required],
      },
    };
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    resetForm() {
      this.form.name = null;
      this.form.last4 = null;
      this.$refs.userDetails.resetFields();
    },
  },
  computed: {
    w2AdHocData() {
      return {
        ...this.form,
        paystubs: this.paystubs,
      };
    },
  },
  components: {
    MaskedElInput,
    W2AdHocPdfButton,
  },
};

</script>
